import React, { useState, useEffect } from "react";
import LogoIcon from "../../assets/Images/MiniLogo.png";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axiosClient from "../../Services/Axios/axios";
import { BeatLoader } from "react-spinners";

const VerificationPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const emailId = localStorage.getItem("email");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);

  const handleOtpChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
  };

  const verifyOtp = async () => {
    const otpString = otp.join("");
    setLoading(true);
    try {
      const response = await axiosClient.post("/users/otp-verification", {
        email: emailId ? emailId : email,
        otp: otpString,
      });
      if (!response.data.error) {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Verification Successful",
        }).then(() => {
          navigate("/login");
        });
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Invalid OTP",
          text: response.data.message,
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error verifying OTP:", error);
      if (error.response && error.response.status === 401) {
        Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text:
            error.response.data.message || "Unauthorized. Please try again.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text: "An error occurred during verification. Please try again later.",
        });
      }
    }
  };

  const hundleResendOTP = async () => {
    const response = await axiosClient.post("/users/resend-otp", {
      email: emailId,
    });
    if (!response.data.error) {
      Swal.fire({
        icon: "success",
        title: response.data.message,
      });
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get("emailId");
    if (emailParam) {
      setEmail(emailParam);
    }
  }, []);
  if (loading)
    return (
      <div className="loader">
        <BeatLoader color="#097C81" />
      </div>
    );
  return (
    <>
      <div className="container-fluid vh-100 d-flex justify-content-center login-container manages_top">
        <div className="row w-100 h-100">
          {/* Left side image */}
          <div className="col-md-6 d-none d-md-block" id="desk_top_hide">
            {/* <div className="h-100 d-flex flex-column justify-content-center align-items-center">
            <img src={LogoIcon} alt="WorldTrust" className="img-fluid" />
            <h5 className="mt-3">Helping with Donations</h5>
          </div> */}
          </div>

          {/* Right side login form */}
          <div
            className="col-md-6 col-sm-12 d-flex flex-column justify-content-center align-items-center"
            id="cnt_managess_area"
          >
            <div className="card p-4 w-100 h-100 d-flex flex-column justify-content-center align-items-center sc_lgo_allss">
              <div className="d-flex justify-content-center   ">
                <img src={LogoIcon} alt="WorldTrust" />
              </div>
              <h3 className="text-center">Email Verification</h3>
              <p
                className="text-center fw-bolder w-75 "
                style={{ color: "green" }}
              >
                We have sent an OTP to your registered email , enter and verify
                your Email ID.
              </p>
              <div className="otp-input-container d-flex justify-content-center mb-4">
                {[...Array(4)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    className="form-control otp-input mx-1"
                    style={{ width: "40px", textAlign: "center" }}
                    value={otp[index]}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyPress={(event) => {
                      if (
                        !/[0-9]/.test(event.key) &&
                        event.key !== "Backspace" &&
                        event.key !== "Tab"
                      ) {
                        event.preventDefault(); // Prevent the default action if the key is not a number
                      }
                    }}
                    onKeyUp={(e) => {
                      if (e.target.value && index < 3) {
                        const nextInput =
                          e.target.parentElement.children[index + 1];
                        nextInput.focus();
                      }
                      if (e.key === "Backspace" && index > 0) {
                        const prevInput =
                          e.target.parentElement.children[index - 1];
                        prevInput.focus();
                      }
                    }}
                  />
                ))}
              </div>
              <div className="d-flex justify-content-center   ">
                <button className="btn bg-natural" onClick={verifyOtp}>
                  Verify Email ID
                </button>
              </div>
              <p className="reset_otp_link">
                <Link to="" onClick={hundleResendOTP}>
                  Resend OTP
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerificationPage;
